var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18974 4.30769V9.18974C1.26154 10.123 1.33333 11.3436 1.40513 12.2051C1.47693 13.2103 2.33846 14 3.34359 14H8.65638C9.66151 14 10.5231 13.2103 10.5949 12.2051C10.6666 11.3436 10.7385 10.123 10.8103 9.18974C10.882 8.11279 10.8103 5.88714 10.8103 4.30769H1.18974Z",
    fill: "#721C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0257 2.15384H9.2308L8.65645 1.07692C8.29749 0.430773 7.65132 0 6.93333 0H5.21028C4.49233 0 3.77438 0.430773 3.48721 1.07692L2.76926 2.15384H0.974381C0.687206 2.15384 0.400024 2.44103 0.400024 2.72821C0.400024 3.01538 0.687206 3.30256 0.974381 3.30256H11.0257C11.3128 3.30256 11.6 3.08718 11.6 2.72821C11.6 2.36923 11.3128 2.15384 11.0257 2.15384ZM3.98977 2.15384L4.34875 1.57949C4.49233 1.2923 4.7795 1.07692 5.13846 1.07692H6.86158C7.22054 1.07692 7.50768 1.22051 7.65132 1.57949L8.01028 2.15384H3.98977Z",
    fill: "#721C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteMenuIcon);
export default __webpack_public_path__ + "static/media/delete-menu-icon.d24cfb00476ef5beedfb0de2ad331864.svg";
export { ForwardRef as ReactComponent };